import React, { useEffect, useRef } from 'react';
import { TweenLite, Power2 } from 'gsap';
import CSSPlugin from 'gsap/CSSPlugin';
import marked from 'marked';

import {
  Container,
  SectionHeader,
  DescriptionSection,
  Description,
  PromotionImage,
  InnerContainer,
  HeaderContainer,
  InnerHeaderContainer,
} from './promoTextContent.styled';
import { PromoTextContentData } from './promoTextContent.types';

export const PromoTextContent: React.FC<PromoTextContentData> = (data: PromoTextContentData) => {
  const { headerContent, description, promotionImage } = data;
  const headerRef = useRef(null);
  
  useEffect(() => {
    TweenLite.set(headerRef.current, { yPercent: 100 });
    TweenLite.to(headerRef.current, {
      scrollTrigger: headerRef.current,
      yPercent: 0,
      duration: 1,
      delay: 0.2,
      ease: Power2.easeOut,
    });
  }, []);

  return (
    <Container>
      <InnerContainer>
        <HeaderContainer>
          <InnerHeaderContainer>
            <SectionHeader dangerouslySetInnerHTML={{__html: marked(headerContent)}} ref={headerRef} />
          </InnerHeaderContainer>
        </HeaderContainer>
        <DescriptionSection>
          <Description>{description}</Description>
          <PromotionImage src={promotionImage?.localFile?.url} alt={promotionImage.alt_text} />
        </DescriptionSection>
      </InnerContainer>
    </Container>
  );
};
